import OperationsRepository from '@/libs/customAxios/operationAxios'
import NightOpsRepository from '@/libs/customAxios/nightOpsAxios'
import ReportsRepository from '@/libs/customAxios/reportsAxios'
import ListsRepository from '@/libs/customAxios/listsAxios'

const sortingResource = '/sorting'
const sortingDeviceResource = '/sorting/devices'
const defaultPagination = 20

export default {
  /**
   * Scan a waybill from a current node
   * @param {Object} payload - { waybill_number: string}
   */
  scanWaybill(payload) {
    return NightOpsRepository.post(`${sortingResource}/scan`, payload)
  },

  /**
   * Get stats for a particular bucket
   * @param {Number} bucketNodeId
   */
  getBucketStats(bucketNodeId) {
    return ReportsRepository.get(`${sortingResource}/stats/${bucketNodeId}`)
  },

  createBag(payload) {
    return OperationsRepository.post(`${sortingResource}/new-bag`, payload)
  },

  fetchBagList(bucketNodeId, sortingIdString) {
    return ListsRepository.get(`${sortingResource}/bag-list?bucketNodeId=${bucketNodeId}&sortingIdString=${sortingIdString}`)
  },

  /**
   * Get stats for a particular bucket
   * @param {String} sortingIdString
   */
  getReportOverall(sortingIdString) {
    return ReportsRepository.get(`${sortingResource}/overall-stats/${sortingIdString}`)
  },

  getSessionStats(sortingIdString) {
    return ReportsRepository.get(`${sortingResource}/session/${sortingIdString}`)
  },

  getScanPerformance(sortingIdString) {
    return ReportsRepository.get(`${sortingResource}/scan-performance-tiles/${sortingIdString}`)
  },

  /**
   * Get stats for a particular bucket
   *
   */
  getReportOverallBuckets({ bucket_id, sorting_id_string }) {
    return ReportsRepository.get(`${sortingResource}/overall-bucket-stats`, {
      params: { bucket_id, sorting_id_string },
    })
  },

  /**
   * Get available buckets to scan into
   */
  getAvailableBuckets() {
    return ListsRepository.get(`${sortingResource}/buckets-available`)
  },

  getAvailableBucketsforReporting() {
    return ListsRepository.get(`${sortingResource}/buckets-available-reporting`)
  },

  /**
   * Login to a particular bucket node
   * @param {Object} payload - { bucket_node_id: number }
   */
  loginBucket(payload) {
    return OperationsRepository.post(`${sortingResource}/login-bucket`, payload)
  },

  /**
   * Logout from a particular bucket node
   * @param {Object} payload - { bucket_node_id: number }
   */
  logoutBucket(payload) {
    return OperationsRepository.post(`${sortingResource}/logout-bucket`, payload)
  },

  getCurrentBucketSession() {
    return OperationsRepository.get('/sorting/current-bucket')
  },

  getUserSessions(pageNumber = 1, pagination = defaultPagination) {
    return OperationsRepository.get(`/sorting/user-sessions?paginate=${pagination}&page=${pageNumber}`)
  },

  getBucketOrdersById(pageNumber = 1, pagination = defaultPagination, id, isReport = true, sortingString, filterQuery) {
    if (isReport) {
      return ListsRepository.get(`${sortingResource}/report/${id}/orders?paginate=${pagination}&page=${pageNumber}&sort=-id&sortingString=${sortingString}`)
    }
    return ListsRepository.get(`${sortingResource}/bucket/${id}/orders?paginate=${pagination}&page=${pageNumber}&sort=-id&sortingString=${sortingString}&${filterQuery}`)
  },

  getBucketOrdersNoPagination(id, isReport = true, sortingString) {
    if (isReport) {
      return ReportsRepository.get(`${sortingResource}/report/${id}/orders?sort=-id&noPagination&sortingString=${sortingString}`)
    }
    return ReportsRepository.get(`${sortingResource}/bucket/${id}/orders?sort=-id&noPagination&sortingString=${sortingString}`)
  },

  orderBulkDispatchStatusUpdate(payload) {
    return NightOpsRepository.post('/sorting/bulk-dispatch-update', payload)
  },

  getSortingDevices(pageNumber = 1, pagination = defaultPagination, filterQuery) {
    return OperationsRepository.get(`${sortingDeviceResource}?paginate=${pagination}&page=${pageNumber}&sort=-id&${filterQuery}`)
  },

  getSortingDevicesNoPagination(filterQuery) {
    return OperationsRepository.get(`${sortingDeviceResource}?${filterQuery}&sort=-id&noPagination`)
  },

  getSortingBranches() {
    return ListsRepository.get(`${sortingDeviceResource}/branch-list`)
  },

  getUnassignedSortingBranches() {
    return ListsRepository.get(`${sortingResource}/nodes/unassigned`)
  },

  createSortingDevice(payload) {
    return OperationsRepository.post(`${sortingDeviceResource}`, payload)
  },

  updateSortingDevice(device, payload) {
    return OperationsRepository.put(`${sortingDeviceResource}/${device}`, payload)
  },

  getSortingDeviceById(device) {
    return OperationsRepository.get(`${sortingDeviceResource}/${device}/device-data`)
  },

  unlinkDevice(device) {
    return OperationsRepository.post(`${sortingDeviceResource}/unlink/${device}`)
  },
}
